import { create } from 'zustand';

export const useUIStore = create((set) => ({
  theme: localStorage.getItem('leadszonemap_theme') || 'dark',
  setTheme: (theme) => {
    localStorage.setItem('leadszonemap_theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    set({ theme });
  },
  toggleTheme: () => set((state) => {
    const next = state.theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem('leadszonemap_theme', next);
    document.documentElement.setAttribute('data-theme', next);
    return { theme: next };
  }),

  // Admin Sidebar state
  adminSidebarExpanded: localStorage.getItem('leadszonemap_sidebar_expanded') !== 'false',
  toggleAdminSidebar: () => set((state) => {
    const next = !state.adminSidebarExpanded;
    localStorage.setItem('leadszonemap_sidebar_expanded', String(next));
    return { adminSidebarExpanded: next };
  }),

  // Client Sidebar state
  clientSidebarExpanded: localStorage.getItem('leadszonemap_client_sidebar_expanded') !== 'false',
  toggleClientSidebar: () => set((state) => {
    const next = !state.clientSidebarExpanded;
    localStorage.setItem('leadszonemap_client_sidebar_expanded', String(next));
    return { clientSidebarExpanded: next };
  }),

  // Active Dashboard Section (Admin)
  activeDashboardSection: 'dashboard-overview',
  setActiveDashboardSection: (section) => set({ activeDashboardSection: section }),

  // Lead View (Client)
  leadView: 'base',
  setLeadView: (view) => set({ leadView: view }),

  // Modals / Overlays
  confirmModal: null,
  setConfirmModal: (modal) => set({ confirmModal: modal }),
  baseValidationReport: null,
  setBaseValidationReport: (report) => set({ baseValidationReport: report }),
}));
